// src/components/account/ReviewsTab.tsx

import React from 'react';
import ReviewCard from './ReviewCard'; // Assuming you create this component

// Define the expected prop types
interface ReviewsTabProps {
  reviews: any[]; // Replace with Review[] type
  handleApproveReview: (reviewId: number) => void;
  handleRemoveReview: (reviewId: number) => void;
  handleRespondToReview: (review: any) => void;
  handleLikeReview: (reviewId: number) => void;
}

const ReviewsTab: React.FC<ReviewsTabProps> = ({
  reviews,
  handleApproveReview,
  handleRemoveReview,
  handleRespondToReview,
  handleLikeReview,
}) => {
  const pendingCount = reviews.filter(r => r.status === 'pending').length;

  return (
    <div className="bg-white rounded-2xl shadow-sm p-8">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Reviews Management</h2>
        <div className="flex gap-2">
          <button className="px-4 py-2 bg-teal-50 text-teal-700 rounded-lg font-medium hover:bg-teal-100 transition-colors cursor-pointer whitespace-nowrap">
            All ({reviews.length})
          </button>
          <button className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap">
            Pending ({pendingCount})
          </button>
        </div>
      </div>

      <div className="space-y-6">
        {reviews.map((review) => (
          <ReviewCard
            key={review.id}
            review={review}
            onApprove={handleApproveReview}
            onRemove={handleRemoveReview}
            onRespond={handleRespondToReview}
            onLike={handleLikeReview}
          />
        ))}
      </div>
    </div>
  );
};

export default ReviewsTab;